import AvatarGroup from "@mui/material/AvatarGroup";
import IndividualAvatar from "marketplace/_views/avatars/individual-avatar";
import { getIndividualsByUserIds } from "marketplace/individuals/_stores/individuals-redux-slice";
import { useSelector } from "react-redux";
import NetworkedGroup from "users/networking/groups/networked-group";

interface AvatarGroupProps {
  group: NetworkedGroup;
  avatarGroupMax?: number;
}

const DEFAULT_AVATAR_GROUP_MAX = 5;

export default function NetworkedGroupAvatarGroup(props: Readonly<AvatarGroupProps>) {

  const { group, avatarGroupMax } = props;

  const individuals = useSelector(getIndividualsByUserIds(group.memberUserIds));

  return (
    <AvatarGroup max={avatarGroupMax ?? DEFAULT_AVATAR_GROUP_MAX}>
      {individuals.map((individual) => (
        <IndividualAvatar
          key={individual.userId.value}
          individual={individual}
        />
      ))}
    </AvatarGroup>
  );
}
